<template>
  <div class="content animate-panel">
    <div v-if="isBasicPlan" class="banner">
      <div class="banner-plan text-size-20">
        プレミアム
      </div>
      <div class="banner-explain">
        <span>にアップグレードして</span>
        <span class="banner-explain__text-xl">限定サービス</span>
        <span>を利用する</span>
      </div>
      <button class="btn btn-warning btn-upgrade-plan text-plan-normal" @click="handleClickUpgradePlan">
        お申込はこちら
        <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
      </button>
    </div>
    <div v-if="dashboardIframeUrl" class="box-dashboard-iframe">
      <iframe id="dashboard-iframe" :src="dashboardIframeUrl" width="100%" height="" frameborder="0"
        allowTransparency="true" />
    </div>
    <modal-amazon-expiration v-if="isShowModalAmazonExpiration && amazonExpirationContext.length"
      :amazonExpirationContext="amazonExpirationContext"></modal-amazon-expiration>
  </div>
</template>

<script>
import ModalAmazonExpiration from '@/components/ModalAmazonExpiration'
import DashboardService from '@/services/dashboardservice'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAmazonExpiration
  },
  data () {
    return {
      loader: null,
      dashboardIframeUrl: null
    }
  },
  created () {
    this.getHomeDashboard()
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    isShowModalAmazonExpiration () {
      let isShowModal = false
      if (this.userInfo.sellerId && localStorage.getItem('isShowModalAmazonExpiration')) {
        isShowModal = true
      }
      return isShowModal
    },
    amazonExpirationContext () {
      /*
        Explain about value expireAt
          1 => 0 ~ 31 days and show modal
          2 => > 31 days and hide modal
          3 => < 0 days and show modal
          4 => null and show modal
      */

      if (!this.userInfo.hasSpAccount || (this.userInfo.hasSpAccount && this.userInfo.enableFlag === false)) {
        return [{
          text: 'セールモンスターへ出品する場合は、Amazonとのデータ連携が必要です。',
          classes: ''
        }]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag === null) {
        return [
          {
            text: 'Amazon側のシステム変更により、',
            classes: ''
          },
          {
            text: '2022年12月31日までにAmazonとのデータ連携を設定して頂く必要があります。',
            classes: 'text-danger text--underline font-weight-normal'
          },
          {
            text: '実施頂けない場合、2023年1月以降にセールモンスターからの出品ができなくなります。',
            classes: 'mr-b-10'
          },
          {
            text: '※既にデータ連携が完了しているセラー様も、再度設定して頂く必要があります。',
            classes: 'text-danger text--underline mr-b-10 font-weight-normal'
          },
          {
            text: 'お手数おかけしますが、よろしくお願いいたします。',
            classes: 'mr-b-10'
          }
        ]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 1) {
        return [
          {
            text: '有効期限が近づいています。',
            classes: 'text-danger text--underline mr-b-10 font-weight-normal'
          },
          {
            text: '以下のボタンより再設定を行ってください。',
            classes: 'mr-b-10'
          }
        ]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 3) {
        return [
          {
            text: '有効期限が切れました。',
            classes: 'text-danger text--underline font-weight-normal'
          },
          {
            text: 'セールモンスターへ出品する場合は、再度Amazonとのデータ連携が必要です。',
            classes: 'mr-b-10'
          },
          {
            text: '以下のボタンより再設定を行ってください。',
            classes: 'mr-b-10'
          }
        ]
      }
      return []
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  methods: {
    getHomeDashboard () {
      this.loader = this.$loading.show()
      DashboardService.getHomeDashboard()
        .then(response => {
          this.dashboardIframeUrl = response.data.iframeUrl
          setTimeout(() => {
            this.loader && this.loader.hide()
            this.handleSetIframe()
          }, 2500)
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    handleSetIframe () {
      $('#dashboard-iframe', window.parent.document).height($('body').height() - 150)
      $('#dashboard-iframe', window.parent.document).addClass('bg-white')
    },
    handleClickUpgradePlan () {
      let logParams = {
        name: eventCode.home.click_upgrade_plan_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      this.$router.push({name: 'Setting', params: {tab: 'plan-info'}})
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.home.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>

<style scoped>
  .animate-panel {
    padding-right: 5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/Home.vue